import { _ } from "../../core/polyglot/polyglot.js";
import {
	allCompanyRoles,
	getPresentationName,
} from "../../models/CompanyUserRoles.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import MultipleItemPickerWidget from "../../core/widgets/MultipleItemPickerWidget/MultipleItemPickerWidget.js";

/**
 * `NotifyUsersWidget` displays a list of users with their email adresses.
 * The user can then select recipients which are accessible through the
 * 'getSelectedUsers' function.
 */
export default class NotifyUsersWidget extends Widget {
	constructor({ currentUser, currentCompany, companyUsers, agencyUsers }) {
		super(...arguments);

		this._currentUser = currentUser;
		this._currentCompany = currentCompany;
		this._pickers = this._createPickers(companyUsers, agencyUsers);
	}

	renderContentOn(html) {
		html.render(this._pickers);
	}

	getSelectedUsers() {
		return this._pickers.flatMap((picker) => picker.selectedValues());
	}

	_userItemRenderer(item) {
		return (html) => {
			html.span(
				{ klass: { disabled: !item.value.hasValidEmail() } },
				this._userEmailRenderer(item.value),
			);
		};
	}

	_userEmailRenderer(user) {
		return (html) => {
			html.span({ klass: "info" }, user.getName());

			html.span(
				user.hasValidEmail()
					? user.getEmail()
					: _("Invalid email address"),
			);
		};
	}

	_createPickers(companyUsers, agencyUsers) {
		const pickers = allCompanyRoles()
			.map((role) => {
				const users = companyUsers.filter(
					(u) => u.roleForCompany(this._currentCompany) === role,
				);
				if (users.length === 0) {
					return null;
				}
				return this._createPicker(getPresentationName(role), users);
			})
			.filter(Boolean);

		pickers.unshift(this._createPicker(_("Yourself"), [this._currentUser]));

		if (agencyUsers.length > 0) {
			pickers.push(this._createPicker(_("Agency user"), agencyUsers));
		}

		return pickers;
	}

	_createPicker(groupTitle, users) {
		return new MultipleItemPickerWidget({
			title: groupTitle,
			itemRenderer: this._userItemRenderer.bind(this),
			items: users.map((user) => this._makeUserSelectable(user, true)),
			collapsed: true,
		});
	}

	_makeUserSelectable(user, isSelected) {
		return {
			selected: isSelected,
			disabled: !user.hasValidEmail(),
			value: user,
		};
	}
}
